// api的baseUrl
export const baseURL = {
  'production': 'https://ijournal-service.topeditsci.com',
  'lan': 'http://journal-service.youpin-k8s.net',
  'development': 'https://testdb-ijournal-service.topeditsci.com'
}[process.env.NODE_ENV]

// java端 api的baseUrl
export const baseURL2 = {
  'production': 'https://ijournal-admin.topeditsci.com:8461',
  'lan': 'https://ijournal-admin.topeditsci.com:8461',
  'development': 'https://ijournal-admin-test.topeditsci.com:8461'
}[process.env.NODE_ENV]

// cookie 域
export const cookieDomain = {
  'production': 'topeditsci.com',
  'lan': 'youpin-k8s.net',
  'development': 'localhost'
}[process.env.NODE_ENV]



// WEBPACK FOOTER //
// ./src/config/index.js